import { Observable } from 'rxjs';
import { DSCustomElement, Driver } from '../core/core-types';

export type Effect = (element?: DSCustomElement) => void;

export function makeGenericEffectsDriver(customElement: DSCustomElement): Driver<Observable<Effect>, void> {
    return (effect$: Observable<Effect>): void => {
        effect$.subscribe({
            next(effect: Effect): void {
                effect(customElement);
            },
            error(): void {
                return;
            },
            complete(): void {
                return;
            }
        });
    };
}
